@if (loading()) {
  <div class="loader-scrim" data-motion="essential">
    <div class="loader-dots">
      @for (dot of dots; track dot) {
        <span class="loader-dot-track">
          <span class="loader-shadow"></span>
          <span class="loader-dot"></span>
        </span>
      }
    </div>

    @if (progress() !== null) {
      <div class="loader-percent">{{ progress() }}%</div>
    }
  </div>
}
